import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { useOrganizations, useSettings } from 'hooks';

const OrganizationDropdown = ({ selectedOrganization, setSelectedOrganization }) => {
  const { organizations } = useOrganizations();
  const { t } = useTranslation();
  const { isSuper } = useSettings();

  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2" gutterBottom component="div" justifySelf="flex-start">
        {t('organization') + ' *'}
      </Typography>
      <MenuWithId
        placeholder="Organization"
        menuItems={!organizations || organizations.length === 0 ? [{ id: 0, name: 'None' }] : organizations}
        selectedItem={selectedOrganization?.name}
        selectItem={(item) => {
          setSelectedOrganization(item);
        }}
        inputProps={{
          maxLength: 24,
        }}
        size="normal"
        enabled={isSuper}
      />
    </Grid>
  );
};

OrganizationDropdown.propTypes = {
  setSelectedOrganization: PropTypes.func.isRequired,
  selectedOrganization: PropTypes.object,
};

OrganizationDropdown.defaultProps = {
  selectedOrganization: undefined,
};

export default OrganizationDropdown;
